import React from "react";
import withStyles from "react-jss";
import Container from "reactstrap/lib/Container";
import { ChannelsList } from "ComponentsUI/Channels";
import { PlaceholderInput } from "ComponentsUI/Placeholderinput";
import { SelectFieldInBlock } from "ComponentsUI/Selectfield";
import { toJS } from "mobx";
import { element } from "prop-types";

const styles = (theme) => ({
	root: {
		minHeight: "100vh",
		width: "100%",
		backgroundColor: theme.palette.colors.paleGrey,
	},
	wrapper: {},
	header: {
		paddingTop: "60px",
		fontFamily: theme.fonts.bold,
		marginBottom: "70px",
		fontSize: "36px",
		lineHeight: 1,
		color: theme.palette.colors.darkSlateBlue,
		textAlign: "center",
	},
	list: {
		padding: "0 100px 30px",
	},
	filters: {
		display: "flex",
		alignItems: "flex-start",
		padding: "0 100px",
		marginBottom: "80px",
	},
	searchSlot: {
		width: "480px",
		marginRight: "46px",
	},
	qualitySlot: {
		width: "280px",
	},
	blockHeader: {
		fontFamily: theme.fonts.bold,
		fontSize: "16px",
		lineHeight: 1,
		letterSpacing: "2.3px",
		color: theme.palette.colors.darkSlateBlue,
		textTransform: "uppercase",
		width: "100%",
		marginBottom: "16px",
	},
	blockInput: {
		width: "100%",
		height: "50px",
		borderRadius: "10px",
		border: `solid 1px ${theme.palette.colors.lightGrayishViolet}`,
		fontFamily: theme.fonts.medium,
		fontSize: "16px",
		lineHeight: 1,
		color: theme.palette.colors.veryDarkGray,
		padding: "0 16px",
		backgroundColor: "rgba(255,255,255, .5)",
		appearance: "none",
		display: "flex",
		alignItems: "center",
		"&:focus": {
			backgroundColor: theme.palette.colors.white,
		},
	},
	placeholder: {
		fontFamily: theme.fonts.light,
		fontSize: "16px",
		lineHeight: 1,
		paddingLeft: "16px",
		color: theme.palette.colors.grayishBlue,
	},
	placeholderInput: {
		width: "100%",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		list: {
			padding: "0 0 30px",
		},
		filters: {
			padding: 0,
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		header: {
			paddingTop: "32px",
			marginBottom: "65px",
		},
		list: {
			padding: "0 0 30px",
		},
		filters: {
			padding: 0,
			marginBottom: "38px",
			justifyContent: "space-between",
		},
		searchSlot: {
			marginRight: "20px",
			flexShrink: 1,
		},
		blockHeader: {
			fontSize: "14px",
			lineHeight: 1.14,
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		header: {
			paddingTop: "42px",
			marginBottom: "40px",
			fontSize: "24px",
		},
		list: {
			padding: "0 0 30px",
		},
		filters: {
			padding: 0,
			marginBottom: "42px",
			flexWrap: "wrap",
		},
		searchSlot: {
			marginRight: 0,
			marginBottom: "24px",
			width: "100%",
		},
		qualitySlot: {
			width: "100%",
		},
		blockHeader: {
			fontSize: "14px",
			lineHeight: 1.14,
		},
	},
});

class Layout extends React.Component {
	render() {
		let classes = this.props.classes;
		let text = this.props.text;
		let provider = this.props.provider;
		let channelsForSelectCheck = this.props.channelsForSelectCheck;
		let outputQualities = [];
		let quality = toJS(provider.quality).map((item) => {
			return {
				...item,
				id: item.code,
			};
		});
		quality.map((item) => {
			if (
				channelsForSelectCheck.some((elem) =>
					elem["quality"].find((elemItem) => elemItem["name"] === item.name)
				)
			) {
				outputQualities.push(item);
			}
		});

		return (
			<div className={classes.root}>
				<Container>
					<div className={classes.wrapper}>
						<div className={classes.header}>
							<div>{`${provider.name} - ${text.CHANNELS_BY_TARIFF} ${this.props.tariffName}`} </div>
							<div>{` ${this.props.channelsText} `} </div>
						</div>
						<div className={classes.filters}>
							<div className={classes.searchSlot}>
								<div className={classes.blockHeader}>{text.SEARCH_BY_NAME}</div>
								<PlaceholderInput
									className={classes.placeholderInput}
									placeholder={text.ENTER_A_NAME_2}
									classNamePlaceholder={classes.placeholder}
								>
									<input
										type="text"
										className={classes.blockInput}
										value={this.props.data.name}
										maxLength={100}
										onChange={(event) => this.props.changeName(event.target.value)}
									/>
								</PlaceholderInput>
							</div>
							<div className={classes.qualitySlot}>
								{!!outputQualities?.length && (
									<SelectFieldInBlock
										multiselect={true}
										windowSizes={this.props.windowSizes}
										items={outputQualities}
										onItemSelect={(items) => this.props.changeQuality(items)}
										text={text}
										isFixedList={true}
										onlyInputDisabled={true}
										transparentType={true}
										title={text.QUALITY}
										findItems={this.props.data.quality}
										placeholder={text.EVERYTHING_2}
										activePlaceHolder={text.EVERYTHING_2}
										isQualityChannels={true}
										transfer={true}
									/>
								)}
							</div>
						</div>
						<div className={classes.list}>
							<ChannelsList
								text={text}
								defaultItems={this.props.channels}
								windowSizes={this.props.windowSizes}
								quality={this.props.quality}
							/>
						</div>
					</div>
				</Container>
			</div>
		);
	}
}

export default withStyles(styles)(Layout);
